import { BASE_URL_API } from 'constants/base-url-default'
import { getCookie } from 'utils/functions-cookie'

type Body = {
  email: string
  name: string
}

export type Response = {
  message: string
  detail?: string
}

export const fetchCreateEmployees = async (data: Body) => {
  const authToken = getCookie('auth_token')
  const response = await fetch(`${BASE_URL_API}/employees/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(data),
  })

  if (response.status === 401) {
    throw new Error('Sessão expirada')
  }

  if (response.status !== 201) {
    const res = (await response.json()) as Response
    return res
  }

  return (await response.json()) as Response
}
